export default __webpack_public_path__ + "static/media/2051.10a09ec2.png";